// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteIcons/reviewSearch.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reviews-space1-jWxTf {
	margin-bottom: 6px !important;
}

.Reviews-space2-Fjvkj {
	margin-bottom: 12px !important;
}

.Reviews-space3-a0mBi {
	margin-bottom: 18px !important;
}

.Reviews-space4-Y6vtb {
	margin-bottom: 24px !important;
}

.Reviews-space5-LUONC {
	margin-bottom: 30px !important;
}

.Reviews-space6-jovP4 {
	margin-bottom: 36px !important;
}

.Reviews-space7-AR7te {
	margin-bottom: 42px !important;
}

.Reviews-spaceTop8-tYcTr {
	margin-bottom: 48px !important;
}

.Reviews-spaceTop1-WSOHk {
	margin-top: 6px !important;
}

.Reviews-spaceTop2-Qs78R {
	margin-top: 12px !important;
}

.Reviews-spaceTop3-G0SRk {
	margin-top: 18px !important;
}

.Reviews-spaceTop4-OPgg0 {
	margin-top: 24px !important;
}

.Reviews-spaceTop5-_3onG {
	margin-top: 30px !important;
}

.Reviews-spaceTop6-OOglj {
	margin-top: 36px !important;
}

.Reviews-spaceTop7-UzFD3 {
	margin-top: 42px !important;
}

.Reviews-spaceTop8-tYcTr {
	margin-top: 48px !important;
}

.Reviews-noMargin-rAsSl {
	margin: 0px !important;
}

.Reviews-padding1-IkaHz {
	padding-bottom: 6px !important;
}

.Reviews-padding2-Ow7v8 {
	padding-bottom: 12px !important;
}

.Reviews-padding3-xFlfD {
	padding-bottom: 18px !important;
}

.Reviews-padding4-tE1P7 {
	padding-bottom: 24px !important;
}

.Reviews-padding5-O42zU {
	padding-bottom: 30px !important;
}

.Reviews-padding6-DTVXP {
	padding-bottom: 36px !important;
}

.Reviews-padding7-idZWQ {
	padding-bottom: 42px !important;
}

.Reviews-paddingTop1-Ty_FG {
	padding-top: 6px !important;
}

.Reviews-paddingTop2-LIrHR {
	padding-top: 12px !important;
}

.Reviews-paddingTop3-HKTPv {
	padding-top: 18px !important;
}

.Reviews-paddingTop4-DpwAG {
	padding-top: 24px !important;
}

.Reviews-paddingTop5-hLkoC {
	padding-top: 30px !important;
}

.Reviews-paddingTop6-pwD22 {
	padding-top: 36px !important;
}

.Reviews-paddingTop7-GdbSJ {
	padding-top: 42px !important;
}

.Reviews-noPadding-OFnJX {
	padding: 0px !important;
}

.Reviews-textBold-SmRnK {
	font-weight: 500 !important;
}

.Reviews-textBolder-HyWdd {
	font-weight: 700 !important;
}

.Reviews-textNormal-I2MOt {
	font-weight: normal !important;
}

.Reviews-spaceBottom20-YSbst {
	margin-bottom: 20px;
}

.Reviews-spaceBottom10-GnGf3 {
	margin-bottom: 10px;
}

.Reviews-marginNone-SssG5 {
	margin: 0;
}

.Reviews-spaceBottom15-eQgFS {
	margin-bottom: 15px;
}

.Reviews-marginTopNone-Z51jW {
	margin-top: 0;
}

.Reviews-spaceTop11-tDjK0 {
	margin-top: 11px;
}

.Reviews-spaceTop21-VQvhI {
	margin-top: 21px;
}

.Reviews-spaceTop20-tPLwj {
	margin-top: 20px;
}

.Reviews-spaceTop10-Jshqy {
	margin-top: 10px;
}

/*New Design Text Colors */

.Reviews-textDarkBlue-Yki2P {
	color: rgb(20, 39, 94) !important;
}

.Reviews-textLightBlue-h5oZQ {
	color: rgb(57, 87, 106) !important;
}

.Reviews-textLightSandleGreen-ZBqRU {
	color: rgb(76, 86, 41) !important;
}

.Reviews-textLightBrown-J4RuE {
	color: rgb(115, 79, 33) !important;
}

.Reviews-textMediumMaroon-wbsva {
	color: rgb(87, 37, 51) !important;
}

.Reviews-textBrown-SXqEG {
	color: rgb(160, 47, 24) !important;
}

.Reviews-textMaroon-z6nkX {
	color: rgb(155, 49, 67) !important;
}

.Reviews-textDarkBrown-v7TlC {
	color: rgb(83, 18, 16) !important;
}

.Reviews-textMediumBrown-KKH63 {
	color: rgb(142, 28, 10) !important;
}

.Reviews-textSkyBlue-n73um {
	color: rgb(37, 117, 141) !important;
}

.Reviews-textGray-kU7K0 {
	color: rgb(77, 65, 51) !important;
}

/*************************Sidenavigation Styles start******************************************/

.Reviews-listContainer-DJGyq {
  padding-left: 0px;
  list-style-type: none;
}

/*************************Sidenavigation Styles end******************************************/

.Reviews-panelHeader-DWXvZ {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.Reviews-listLayout-K8uOz {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
}

.Reviews-description-qezEy {
  font-size: 14px;
  line-height: 1.43;
}

a {
  color: var(--primary-link-foreground);
  text-decoration: none;

}

a:hover,
a:focus,
a:active {
  color: var(--primary-link-foreground);
  cursor: pointer;
  text-decoration: none;
}

.Reviews-mediaContainer-YYqmn {
  display: table;
  position: relative;
}

.Reviews-profileAvatarLink-m0yKP {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 50%;
}

.Reviews-avatarDisplay-yLAlP {
  display: table-cell;
}

.Reviews-noBorder-WmrdA {
  border: 0px none !important;
}

.Reviews-panelNolist-PzAsD {
  border-radius: 8px;
  background: var(--primary-gray-bg);
  margin-bottom: 0px;
  padding: 25px 25px 0;
}

.Reviews-textCenter-qIH_R {
  text-align: center;
  position: relative;
  z-index: 5;
}

.Reviews-textBold-SmRnK {
  font-weight: bold;
}

.Reviews-pullLeft-m4KGw {
  float: left;
  margin-right: 2px;
}

.Reviews-listStyle-tr0I8 {
  list-style: none;
  padding: 0;
}

.Reviews-mediaDisplay-kY0ZN {
  padding: 0;
  list-style: none;
  margin-bottom: 25px;
}

.Reviews-mediaDisplayCell-To0If {
  display: table-cell;
}

.Reviews-mediaDisplay-kY0ZN:last-child {
  padding-bottom: 25px;
}

.Reviews-name-DAnkW {
  margin: 4px 0;
  max-width: 74px;
  word-wrap: break-word;
}

.Reviews-reviewMuted-G8EHc {
  color: var(--secondary-foreground);
  margin: 5px 0 12px;
  font-size: 12px;
}

.Reviews-reviewTitle-G26Th {
  font-weight: bold;
  color: var(--primary-foreground);
}

.Reviews-iconColor-rGe1T {
  color: var(--primary-bg);
  font-size: 16px;
}

.Reviews-horizontalLineThrough-flBX0 {
  position: relative;
  z-index: 1;
  display: block;
  margin: 15px 0px;
  width: 100%;
  color: var(--primary-border);
  text-align: center;
  font-size: 14px;
}

.Reviews-tabs-ZU4zX {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
  display: table;
  table-layout: fixed;
  width: 100%;
  font-size: inherit;
  border-bottom: 0px solid var(--primary-border);
  margin-left: 0px;

}

.Reviews-tabs-ZU4zX>li {
  margin-right: 27px;
}

.Reviews-tabItem-tYZQH {
  display: block;
  position: relative;
  text-align: center;
  color: var(--primary-foreground);
  cursor: pointer;
  border-bottom: 3px solid transparent;
  font-size: 22px;
  font-weight: 600;
}

.Reviews-tabItem-tYZQH:hover {
  text-decoration: none;
  color: var(--primary-foreground);
}

.Reviews-active-pblRw .Reviews-tabItem-tYZQH {
  color: var(--secondary-bg) !important;
  border-color: var(--secondary-bg);
  text-decoration: none;
}

.Reviews-showSm-lI45x {
  display: none;
}

.Reviews-recommondations-pxd1_ {
  position: relative;
}

.Reviews-recommondations-pxd1_ li:last-child .Reviews-horizontalLineThrough-flBX0 {
  opacity: 0;
  height: 0;
  margin: 0px;
}

.Reviews-btnRadius-HhW1B {
  border-radius: 0px;
}

.Reviews-linkBtn-ppKmO {
  border-radius: 4px;
  padding: 9px 21px;
}

.Reviews-noBackground-c_8Oz {
  background: transparent !important;
}

.Reviews-displayTable-UWMwe {
  display: table;
  width: 100%;
}

.Reviews-displayTableRow-s7kni {
  padding: 30px 25px;
}

.Reviews-displayTableCell-tyzAy {
  display: table-cell;
  vertical-align: top;
}

.Reviews-rightBg-Z8hxN {
  padding: 15px 10px;
  position: relative;
  width: 100%;
  margin-left: 5px;

}

.Reviews-LeftBg-Rmfbu {
  width: 10%;
}

.Reviews-marginTop-SFyNv {
  margin-top: 30px;
}

.Reviews-nameBold-PWlWw {
  font-weight: bold;
  font-size: 16px;
}

.Reviews-loadMoreLink-Fj089 {
  display: block;
  width: 100%;
  max-width: 200px !important;
}

.Reviews-wordbreak-sbamZ {
  word-break: break-word;
}

.Reviews-pullRight-I9_8F {
  float: right;
}

.Reviews-contentTop-u84cZ {
  margin: 5px 0 20px;
  border-bottom: 1px solid var(--primary-border);
  padding-bottom: 20px;

}

.Reviews-mediaDisplayCell-To0If p {
  font-size: 18px;
}

.Reviews-icons-ViDrn {
  width: 18px;
  margin: -4px 5px 0 0px;
}

.Reviews-writeIconCss-HAhzz {
  width: 14px;
  margin: -4px 5px 0 0px;
}

.Reviews-reviewIcon-DZGMY {
  width: 10px;
  margin: -4px 5px 0 0px;
}

.Reviews-reviewPanel-hEGaI {
  padding: 22px 25px;
  border-radius: 8px;
  border: 1px solid var(--primary-border);
}

.Reviews-listAvatarGrid-KCzWZ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 18px;
  -webkit-column-gap: 8px;
     -moz-column-gap: 8px;
          column-gap: 8px;
}

.Reviews-listDeatilsGrid-FN_K4 {
  width: 100%;
  background-color: var(--background-primary);
  padding: 20px;
  border-radius: 0 8px 8px 8px;
  position: relative;
  -webkit-column-gap: 8px;
     -moz-column-gap: 8px;
          column-gap: 8px;
}

.Reviews-reviewFlex-BAYoe {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 4px;
     -moz-column-gap: 4px;
          column-gap: 4px;
  margin-top: 8px;
  font-size: 12px;
}

.Reviews-dateReviewCss-fWprx {
  padding-left: 11px;
  position: relative;
  color: var(--secondary-foreground);
}

.Reviews-dateReviewCss-fWprx::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 2px;
  width: 3px;
  height: 3px;
  background: var(--primary-foreground);
  border-radius: 50%;
  -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
          transform: translateY(-50%);
}

.Reviews-responseFlex-MYAIO {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 12px;
     -moz-column-gap: 12px;
          column-gap: 12px;
}

.Reviews-responseTitle-AlKnG {
  font-size: 16px;
  font-weight: 600;
}

.Reviews-writeReviewText-jiTwc {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 25px;
}

.Reviews-searchBox-BMn1w {
  margin-top: 28px;
}

.Reviews-searchReviewInput-lFktC {
  height: 45px;
  border-radius: 23px;
  border: 1px solid var(--primary-border);
  max-width: 382px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 18px 50%;
  padding-left: 40px;
  padding-right: 20px;
  background-repeat: no-repeat;
}

.Reviews-rightText-s99sC {
  text-align: end;
}

.Reviews-writtenReviewTitle-Lo9RF {
  font-size: 16px;
  font-weight: 600;
}

.Reviews-loadMoreBtn-FRfDf {
  padding: 12px 20px;
}

.Reviews-noBackground-c_8Oz img {
  background-color: transparent;
}

.Reviews-reviewEditProfile-ZpJh_ {
  float: right;
  margin-right: 0 !important;
  font-size: 16px;
}

.Reviews-editProfileArrow-wK92T {
  margin-left: 5px;
}

.Reviews-noResponse-heM_M {
  border-bottom: 0;
  padding-bottom: 0;
  margin-bottom: 3px;
}

.Reviews-noListHeading-ysCh8 {
  font-size: 20px;
  margin: 19px 0 10px;
}

.Reviews-noListSubHeading-XWVIG {
  color: var(--secondary-foreground);
}

.Reviews-textCenter-qIH_R {
  text-align: center;
}

.Reviews-addNewBtn-lUY3m {
  padding: 13px 15px;
  margin-top: 30px;
  display: inline-block;
}

.Reviews-editReviewCss-gIlIF {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-column-gap: 3px;
     -moz-column-gap: 3px;
          column-gap: 3px;
}

.Reviews-marginTop-SFyNv {
  margin-top: 30px;
}

.Reviews-panelNolistBottom-LFhkj {
  padding-bottom: 7px;
}

.Reviews-pastReviewBottom-ab10d:last-child {
  padding-bottom: 7px;
}

.Reviews-writeReviewIcon-BDPle {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 15px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

@media screen and (max-width: 767px) {
  .Reviews-mediaDisplay-kY0ZN {
    display: block;
  }

  .Reviews-textAlignCenter-SLBCj {
    text-align: left;
  }

  .Reviews-name-DAnkW {
    width: 100%;
    max-width: 100%;
  }

  .Reviews-mediaContainer-YYqmn {
    display: block;
    text-align: center;
  }

  .Reviews-avatarWrapper-fDA1M {
    float: none;
  }

  .Reviews-pullLeft-m4KGw {
    float: none;
  }

  .Reviews-panelNolist-PzAsD {
    padding: 12px;
  }

  .Reviews-listDeatilsGrid-FN_K4 {
    padding: 12px;
  }

  .Reviews-profileAvatar-kLcVt {
    width: 35px;
    height: 35px;
  }

  .Reviews-writeReviewText-jiTwc {
    font-size: 14px;
  }

  .Reviews-nameBold-PWlWw {
    font-size: 14px;
  }

  .Reviews-reviewPanel-hEGaI {
    padding: 17px 10px;
  }

  .Reviews-mobWidth-bZwUj {
    width: 100%;
  }

  .Reviews-reviewEditProfile-ZpJh_ {
    float: none;
    margin-top: 15px;
  }

  .Reviews-editReviewCss-gIlIF {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
  }

  .Reviews-writeReviewIcon-BDPle {
    gap: 10px;
  }

  .Reviews-tabs-ZU4zX>li {
    margin-right: 8px;
  }

  .Reviews-reviewEditProfile-ZpJh_ {
    text-align: right;
  }

  .Reviews-mediaDisplay-kY0ZN:last-child {
    padding-bottom: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Reviews/Reviews.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,+FAA+F;;AAC/F;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,6FAA6F;;AAC7F;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;;AAEvB;;AAEA;;;EAGE,qCAAqC;EACrC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;AAElB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,oBAAoB;;AAEtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAmB;EACnB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,mDAA6D;EAC7D,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n/*************************Sidenavigation Styles start******************************************/\n.listContainer {\n  padding-left: 0px;\n  list-style-type: none;\n}\n\n/*************************Sidenavigation Styles end******************************************/\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.listLayout {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n\n.description {\n  font-size: 14px;\n  line-height: 1.43;\n}\n\na {\n  color: var(--primary-link-foreground);\n  text-decoration: none;\n\n}\n\na:hover,\na:focus,\na:active {\n  color: var(--primary-link-foreground);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.mediaContainer {\n  display: table;\n  position: relative;\n}\n\n.profileAvatarLink {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-block;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.avatarDisplay {\n  display: table-cell;\n}\n\n.noBorder {\n  border: 0px none !important;\n}\n\n.panelNolist {\n  border-radius: 8px;\n  background: var(--primary-gray-bg);\n  margin-bottom: 0px;\n  padding: 25px 25px 0;\n}\n\n.textCenter {\n  text-align: center;\n  position: relative;\n  z-index: 5;\n}\n\n.textBold {\n  font-weight: bold;\n}\n\n.pullLeft {\n  float: left;\n  margin-right: 2px;\n}\n\n.listStyle {\n  list-style: none;\n  padding: 0;\n}\n\n.mediaDisplay {\n  padding: 0;\n  list-style: none;\n  margin-bottom: 25px;\n}\n\n.mediaDisplayCell {\n  display: table-cell;\n}\n\n.mediaDisplay:last-child {\n  padding-bottom: 25px;\n}\n\n.name {\n  margin: 4px 0;\n  max-width: 74px;\n  word-wrap: break-word;\n}\n\n.reviewMuted {\n  color: var(--secondary-foreground);\n  margin: 5px 0 12px;\n  font-size: 12px;\n}\n\n.reviewTitle {\n  font-weight: bold;\n  color: var(--primary-foreground);\n}\n\n.iconColor {\n  color: var(--primary-bg);\n  font-size: 16px;\n}\n\n.horizontalLineThrough {\n  position: relative;\n  z-index: 1;\n  display: block;\n  margin: 15px 0px;\n  width: 100%;\n  color: var(--primary-border);\n  text-align: center;\n  font-size: 14px;\n}\n\n.tabs {\n  margin-bottom: 0;\n  padding: 0;\n  list-style: none;\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n  font-size: inherit;\n  border-bottom: 0px solid var(--primary-border);\n  margin-left: 0px;\n\n}\n\n.tabs>li {\n  margin-right: 27px;\n}\n\n.tabItem {\n  display: block;\n  position: relative;\n  text-align: center;\n  color: var(--primary-foreground);\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  font-size: 22px;\n  font-weight: 600;\n}\n\n.tabItem:hover {\n  text-decoration: none;\n  color: var(--primary-foreground);\n}\n\n.active .tabItem {\n  color: var(--secondary-bg) !important;\n  border-color: var(--secondary-bg);\n  text-decoration: none;\n}\n\n.showSm {\n  display: none;\n}\n\n.recommondations {\n  position: relative;\n}\n\n.recommondations li:last-child .horizontalLineThrough {\n  opacity: 0;\n  height: 0;\n  margin: 0px;\n}\n\n.btnRadius {\n  border-radius: 0px;\n}\n\n.linkBtn {\n  border-radius: 4px;\n  padding: 9px 21px;\n}\n\n.noBackground {\n  background: transparent !important;\n}\n\n.displayTable {\n  display: table;\n  width: 100%;\n}\n\n.displayTableRow {\n  padding: 30px 25px;\n}\n\n.displayTableCell {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.rightBg {\n  padding: 15px 10px;\n  position: relative;\n  width: 100%;\n  margin-left: 5px;\n\n}\n\n.LeftBg {\n  width: 10%;\n}\n\n.marginTop {\n  margin-top: 30px;\n}\n\n.nameBold {\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.loadMoreLink {\n  display: block;\n  width: 100%;\n  max-width: 200px !important;\n}\n\n.wordbreak {\n  word-break: break-word;\n}\n\n.pullRight {\n  float: right;\n}\n\n.contentTop {\n  margin: 5px 0 20px;\n  border-bottom: 1px solid var(--primary-border);\n  padding-bottom: 20px;\n\n}\n\n.mediaDisplayCell p {\n  font-size: 18px;\n}\n\n.icons {\n  width: 18px;\n  margin: -4px 5px 0 0px;\n}\n\n.writeIconCss {\n  width: 14px;\n  margin: -4px 5px 0 0px;\n}\n\n.reviewIcon {\n  width: 10px;\n  margin: -4px 5px 0 0px;\n}\n\n.reviewPanel {\n  padding: 22px 25px;\n  border-radius: 8px;\n  border: 1px solid var(--primary-border);\n}\n\n.listAvatarGrid {\n  display: flex;\n  margin-bottom: 18px;\n  column-gap: 8px;\n}\n\n.listDeatilsGrid {\n  width: 100%;\n  background-color: var(--background-primary);\n  padding: 20px;\n  border-radius: 0 8px 8px 8px;\n  position: relative;\n  column-gap: 8px;\n}\n\n.reviewFlex {\n  display: flex;\n  column-gap: 4px;\n  margin-top: 8px;\n  font-size: 12px;\n}\n\n.dateReviewCss {\n  padding-left: 11px;\n  position: relative;\n  color: var(--secondary-foreground);\n}\n\n.dateReviewCss::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 2px;\n  width: 3px;\n  height: 3px;\n  background: var(--primary-foreground);\n  border-radius: 50%;\n  transform: translateY(-50%);\n}\n\n.responseFlex {\n  display: flex;\n  column-gap: 12px;\n}\n\n.responseTitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.writeReviewText {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 25px;\n}\n\n.searchBox {\n  margin-top: 28px;\n}\n\n.searchReviewInput {\n  height: 45px;\n  border-radius: 23px;\n  border: 1px solid var(--primary-border);\n  max-width: 382px;\n  width: 100%;\n  background: url('../../../public/SiteIcons/reviewSearch.svg');\n  background-position: 18px 50%;\n  padding-left: 40px;\n  padding-right: 20px;\n  background-repeat: no-repeat;\n}\n\n.rightText {\n  text-align: end;\n}\n\n.writtenReviewTitle {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.loadMoreBtn {\n  padding: 12px 20px;\n}\n\n.noBackground img {\n  background-color: transparent;\n}\n\n.reviewEditProfile {\n  float: right;\n  margin-right: 0 !important;\n  font-size: 16px;\n}\n\n.editProfileArrow {\n  margin-left: 5px;\n}\n\n.noResponse {\n  border-bottom: 0;\n  padding-bottom: 0;\n  margin-bottom: 3px;\n}\n\n.noListHeading {\n  font-size: 20px;\n  margin: 19px 0 10px;\n}\n\n.noListSubHeading {\n  color: var(--secondary-foreground);\n}\n\n.textCenter {\n  text-align: center;\n}\n\n.addNewBtn {\n  padding: 13px 15px;\n  margin-top: 30px;\n  display: inline-block;\n}\n\n.editReviewCss {\n  display: flex;\n  align-items: center;\n  column-gap: 3px;\n}\n\n.marginTop {\n  margin-top: 30px;\n}\n\n.panelNolistBottom {\n  padding-bottom: 7px;\n}\n\n.pastReviewBottom:last-child {\n  padding-bottom: 7px;\n}\n\n.writeReviewIcon {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n@media screen and (max-width: 767px) {\n  .mediaDisplay {\n    display: block;\n  }\n\n  .textAlignCenter {\n    text-align: left;\n  }\n\n  .name {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .mediaContainer {\n    display: block;\n    text-align: center;\n  }\n\n  .avatarWrapper {\n    float: none;\n  }\n\n  .pullLeft {\n    float: none;\n  }\n\n  .panelNolist {\n    padding: 12px;\n  }\n\n  .listDeatilsGrid {\n    padding: 12px;\n  }\n\n  .profileAvatar {\n    width: 35px;\n    height: 35px;\n  }\n\n  .writeReviewText {\n    font-size: 14px;\n  }\n\n  .nameBold {\n    font-size: 14px;\n  }\n\n  .reviewPanel {\n    padding: 17px 10px;\n  }\n\n  .mobWidth {\n    width: 100%;\n  }\n\n  .reviewEditProfile {\n    float: none;\n    margin-top: 15px;\n  }\n\n  .editReviewCss {\n    justify-content: center;\n  }\n\n  .writeReviewIcon {\n    gap: 10px;\n  }\n\n  .tabs>li {\n    margin-right: 8px;\n  }\n\n  .reviewEditProfile {\n    text-align: right;\n  }\n\n  .mediaDisplay:last-child {\n    padding-bottom: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Reviews-space1-jWxTf`,
	"space2": `Reviews-space2-Fjvkj`,
	"space3": `Reviews-space3-a0mBi`,
	"space4": `Reviews-space4-Y6vtb`,
	"space5": `Reviews-space5-LUONC`,
	"space6": `Reviews-space6-jovP4`,
	"space7": `Reviews-space7-AR7te`,
	"spaceTop8": `Reviews-spaceTop8-tYcTr`,
	"spaceTop1": `Reviews-spaceTop1-WSOHk`,
	"spaceTop2": `Reviews-spaceTop2-Qs78R`,
	"spaceTop3": `Reviews-spaceTop3-G0SRk`,
	"spaceTop4": `Reviews-spaceTop4-OPgg0`,
	"spaceTop5": `Reviews-spaceTop5-_3onG`,
	"spaceTop6": `Reviews-spaceTop6-OOglj`,
	"spaceTop7": `Reviews-spaceTop7-UzFD3`,
	"noMargin": `Reviews-noMargin-rAsSl`,
	"padding1": `Reviews-padding1-IkaHz`,
	"padding2": `Reviews-padding2-Ow7v8`,
	"padding3": `Reviews-padding3-xFlfD`,
	"padding4": `Reviews-padding4-tE1P7`,
	"padding5": `Reviews-padding5-O42zU`,
	"padding6": `Reviews-padding6-DTVXP`,
	"padding7": `Reviews-padding7-idZWQ`,
	"paddingTop1": `Reviews-paddingTop1-Ty_FG`,
	"paddingTop2": `Reviews-paddingTop2-LIrHR`,
	"paddingTop3": `Reviews-paddingTop3-HKTPv`,
	"paddingTop4": `Reviews-paddingTop4-DpwAG`,
	"paddingTop5": `Reviews-paddingTop5-hLkoC`,
	"paddingTop6": `Reviews-paddingTop6-pwD22`,
	"paddingTop7": `Reviews-paddingTop7-GdbSJ`,
	"noPadding": `Reviews-noPadding-OFnJX`,
	"textBold": `Reviews-textBold-SmRnK`,
	"textBolder": `Reviews-textBolder-HyWdd`,
	"textNormal": `Reviews-textNormal-I2MOt`,
	"spaceBottom20": `Reviews-spaceBottom20-YSbst`,
	"spaceBottom10": `Reviews-spaceBottom10-GnGf3`,
	"marginNone": `Reviews-marginNone-SssG5`,
	"spaceBottom15": `Reviews-spaceBottom15-eQgFS`,
	"marginTopNone": `Reviews-marginTopNone-Z51jW`,
	"spaceTop11": `Reviews-spaceTop11-tDjK0`,
	"spaceTop21": `Reviews-spaceTop21-VQvhI`,
	"spaceTop20": `Reviews-spaceTop20-tPLwj`,
	"spaceTop10": `Reviews-spaceTop10-Jshqy`,
	"textDarkBlue": `Reviews-textDarkBlue-Yki2P`,
	"textLightBlue": `Reviews-textLightBlue-h5oZQ`,
	"textLightSandleGreen": `Reviews-textLightSandleGreen-ZBqRU`,
	"textLightBrown": `Reviews-textLightBrown-J4RuE`,
	"textMediumMaroon": `Reviews-textMediumMaroon-wbsva`,
	"textBrown": `Reviews-textBrown-SXqEG`,
	"textMaroon": `Reviews-textMaroon-z6nkX`,
	"textDarkBrown": `Reviews-textDarkBrown-v7TlC`,
	"textMediumBrown": `Reviews-textMediumBrown-KKH63`,
	"textSkyBlue": `Reviews-textSkyBlue-n73um`,
	"textGray": `Reviews-textGray-kU7K0`,
	"listContainer": `Reviews-listContainer-DJGyq`,
	"panelHeader": `Reviews-panelHeader-DWXvZ`,
	"listLayout": `Reviews-listLayout-K8uOz`,
	"description": `Reviews-description-qezEy`,
	"mediaContainer": `Reviews-mediaContainer-YYqmn`,
	"profileAvatarLink": `Reviews-profileAvatarLink-m0yKP`,
	"avatarDisplay": `Reviews-avatarDisplay-yLAlP`,
	"noBorder": `Reviews-noBorder-WmrdA`,
	"panelNolist": `Reviews-panelNolist-PzAsD`,
	"textCenter": `Reviews-textCenter-qIH_R`,
	"pullLeft": `Reviews-pullLeft-m4KGw`,
	"listStyle": `Reviews-listStyle-tr0I8`,
	"mediaDisplay": `Reviews-mediaDisplay-kY0ZN`,
	"mediaDisplayCell": `Reviews-mediaDisplayCell-To0If`,
	"name": `Reviews-name-DAnkW`,
	"reviewMuted": `Reviews-reviewMuted-G8EHc`,
	"reviewTitle": `Reviews-reviewTitle-G26Th`,
	"iconColor": `Reviews-iconColor-rGe1T`,
	"horizontalLineThrough": `Reviews-horizontalLineThrough-flBX0`,
	"tabs": `Reviews-tabs-ZU4zX`,
	"tabItem": `Reviews-tabItem-tYZQH`,
	"active": `Reviews-active-pblRw`,
	"showSm": `Reviews-showSm-lI45x`,
	"recommondations": `Reviews-recommondations-pxd1_`,
	"btnRadius": `Reviews-btnRadius-HhW1B`,
	"linkBtn": `Reviews-linkBtn-ppKmO`,
	"noBackground": `Reviews-noBackground-c_8Oz`,
	"displayTable": `Reviews-displayTable-UWMwe`,
	"displayTableRow": `Reviews-displayTableRow-s7kni`,
	"displayTableCell": `Reviews-displayTableCell-tyzAy`,
	"rightBg": `Reviews-rightBg-Z8hxN`,
	"LeftBg": `Reviews-LeftBg-Rmfbu`,
	"marginTop": `Reviews-marginTop-SFyNv`,
	"nameBold": `Reviews-nameBold-PWlWw`,
	"loadMoreLink": `Reviews-loadMoreLink-Fj089`,
	"wordbreak": `Reviews-wordbreak-sbamZ`,
	"pullRight": `Reviews-pullRight-I9_8F`,
	"contentTop": `Reviews-contentTop-u84cZ`,
	"icons": `Reviews-icons-ViDrn`,
	"writeIconCss": `Reviews-writeIconCss-HAhzz`,
	"reviewIcon": `Reviews-reviewIcon-DZGMY`,
	"reviewPanel": `Reviews-reviewPanel-hEGaI`,
	"listAvatarGrid": `Reviews-listAvatarGrid-KCzWZ`,
	"listDeatilsGrid": `Reviews-listDeatilsGrid-FN_K4`,
	"reviewFlex": `Reviews-reviewFlex-BAYoe`,
	"dateReviewCss": `Reviews-dateReviewCss-fWprx`,
	"responseFlex": `Reviews-responseFlex-MYAIO`,
	"responseTitle": `Reviews-responseTitle-AlKnG`,
	"writeReviewText": `Reviews-writeReviewText-jiTwc`,
	"searchBox": `Reviews-searchBox-BMn1w`,
	"searchReviewInput": `Reviews-searchReviewInput-lFktC`,
	"rightText": `Reviews-rightText-s99sC`,
	"writtenReviewTitle": `Reviews-writtenReviewTitle-Lo9RF`,
	"loadMoreBtn": `Reviews-loadMoreBtn-FRfDf`,
	"reviewEditProfile": `Reviews-reviewEditProfile-ZpJh_`,
	"editProfileArrow": `Reviews-editProfileArrow-wK92T`,
	"noResponse": `Reviews-noResponse-heM_M`,
	"noListHeading": `Reviews-noListHeading-ysCh8`,
	"noListSubHeading": `Reviews-noListSubHeading-XWVIG`,
	"addNewBtn": `Reviews-addNewBtn-lUY3m`,
	"editReviewCss": `Reviews-editReviewCss-gIlIF`,
	"panelNolistBottom": `Reviews-panelNolistBottom-LFhkj`,
	"pastReviewBottom": `Reviews-pastReviewBottom-ab10d`,
	"writeReviewIcon": `Reviews-writeReviewIcon-BDPle`,
	"textAlignCenter": `Reviews-textAlignCenter-SLBCj`,
	"avatarWrapper": `Reviews-avatarWrapper-fDA1M`,
	"profileAvatar": `Reviews-profileAvatar-kLcVt`,
	"mobWidth": `Reviews-mobWidth-bZwUj`
};
module.exports = ___CSS_LOADER_EXPORT___;
